module.exports = __webpack_public_path__ + "fannie.2nM09MvV.jpg";